import { DependencyList, useEffect } from "react";

export default function useIntersectionObserver(
  intersectionTargetId: string,
  deps: DependencyList,
  callbackFn: (entry: IntersectionObserverEntry) => void,
  root?: string
) {
  // Intersection Observer
  const callback: IntersectionObserverCallback = (entries) => {
    entries.forEach(callbackFn);
  };

  useEffect(() => {
    const options = {
      root: root ? document.getElementById(root) : undefined,
      rootMargin: "0px 0px 0px 0px",
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    };

    const observer = new IntersectionObserver(callback, options);

    const element = document.getElementById(intersectionTargetId);
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, deps);
}
